import { styled } from '@mui/material/styles';
const PREFIX = 'SidebarItemsList';
export const classes = {
    root: `${PREFIX}-root`,
    list: `${PREFIX}-list`,
    listItem: `${PREFIX}-listItem`,
    activeListItem: `${PREFIX}-activeListItem`,
    listItemText: `${PREFIX}-listItemText`,
    listItemIcon: `${PREFIX}-listItemIcon`,
};
const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
        backgroundColor: theme.palette.background.paper,
    },
    [`& .${classes.list}`]: {
        flexGrow: 1,
    },
    [`& .${classes.listItem}`]: {
        cursor: 'pointer',
        color: theme.palette.grey[700],
        '&:hover': {
            [`& .${classes.listItemIcon}`]: {
                color: theme.palette.primary.main,
            },
            [`& .${classes.listItemText}`]: {
                color: theme.palette.primary.main,
            },
        },
        '& + &': {
            marginTop: theme.spacing(1),
        },
    },
    [`& .${classes.activeListItem}`]: {
        [`& .${classes.listItemText}`]: {
            color: theme.palette.primary.main,
        },
        [`& .${classes.listItemIcon}`]: {
            color: theme.palette.primary.main,
        },
    },
    [`& .${classes.listItemText}`]: {
        fontWeight: 500,
        color: theme.palette.grey[700],
        marginLeft: theme.spacing(1),
        height: 24,
        marginTop: 0,
        marginBottom: 0,
    },
    [`& .${classes.listItemIcon}`]: {
        color: theme.palette.grey[700],
        minWidth: 24,
    },
}));
export default Root;
//# sourceMappingURL=styled.js.map